import { render, staticRenderFns } from "./Vote2.vue?vue&type=template&id=e8349572&scoped=true&"
import script from "./Vote2.vue?vue&type=script&lang=ts&"
export * from "./Vote2.vue?vue&type=script&lang=ts&"
import style0 from "./Vote2.vue?vue&type=style&index=0&id=e8349572&prod&lang=css&"
import style1 from "./Vote2.vue?vue&type=style&index=1&id=e8349572&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8349572",
  null
  
)

export default component.exports